module.exports = __webpack_public_path__ + "img/17_97.63984530.png";